// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Analytics_Types_Item from "../Restaumatic.Analytics.Types.Item/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq1 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString));
var eq2 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Eq.eqArray(Restaumatic_Analytics_Types_Item.eqItem));
var eq3 = /* #__PURE__ */ Data_Eq.eq(Data_Money_Rounded.eqMoney);
var affiliationIsSymbol = {
    reflectSymbol: function () {
        return "affiliation";
    }
};
var couponIsSymbol = {
    reflectSymbol: function () {
        return "coupon";
    }
};
var itemsIsSymbol = {
    reflectSymbol: function () {
        return "items";
    }
};
var shippingIsSymbol = {
    reflectSymbol: function () {
        return "shipping";
    }
};
var totalIsSymbol = {
    reflectSymbol: function () {
        return "total";
    }
};
var transactionIdIsSymbol = {
    reflectSymbol: function () {
        return "transactionId";
    }
};
var PurchaseItemIsSymbol = {
    reflectSymbol: function () {
        return "PurchaseItem";
    }
};
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode);
var encodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney);
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode);
var decodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney);
var PurchaseItem = function (x) {
    return x;
};
var toFillFormTypePurchaseIte = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypePurchaseItem_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldPurchaseItem = function (dictHasField) {
    return dictHasField;
};
var eqPurchaseItem = {
    eq: function (x) {
        return function (y) {
            return x.affiliation === y.affiliation && eq1(x.coupon)(y.coupon) && eq2(x.items)(y.items) && eq3(x.shipping)(y.shipping) && eq3(x.total)(y.total) && x.transactionId === y.transactionId;
        };
    }
};
var genericPurchaseItem = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showPurchaseItem = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPurchaseItem)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(affiliationIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(couponIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(itemsIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(shippingIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(totalIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(transactionIdIsSymbol)(Data_Show.showString))(Data_Money_Rounded.showMoney))(Data_Money_Rounded.showMoney))(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Analytics_Types_Item.showItem)))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(Data_Show.showString))))(PurchaseItemIsSymbol))
};
var unscrambleDecodePurchaseItem = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPurchaseItem)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(affiliationIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(couponIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons(itemsIsSymbol)(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Analytics_Types_Item.unscrambleDecodeItem))(/* #__PURE__ */ Unscramble.decodeRecordCons(shippingIsSymbol)(Data_Money_Rounded.udecodeMoney)(/* #__PURE__ */ Unscramble.decodeRecordCons(totalIsSymbol)(Data_Money_Rounded.udecodeMoney)(/* #__PURE__ */ Unscramble.decodeRecordCons(transactionIdIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil))))))))))(Unscramble_Generic.defaultOptions)
};
var encodePurchaseItem = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPurchaseItem)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(PurchaseItemIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(transactionIdIsSymbol)(encodeWithOptionsOther))(totalIsSymbol)(encodeWithOptionsOther1))(shippingIsSymbol)(encodeWithOptionsOther1))(itemsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Analytics_Types_Item.encodeItem))))(couponIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))(affiliationIsSymbol)(encodeWithOptionsOther)))))
};
var decodePurchaseItem = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPurchaseItem)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(PurchaseItemIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(transactionIdIsSymbol)(decodeWithOptionsOther)())(totalIsSymbol)(decodeWithOptionsOther1)())(shippingIsSymbol)(decodeWithOptionsOther1)())(itemsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Analytics_Types_Item.decodeItem)))())(couponIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())(affiliationIsSymbol)(decodeWithOptionsOther)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    PurchaseItem,
    genericPurchaseItem,
    eqPurchaseItem,
    showPurchaseItem,
    encodePurchaseItem,
    decodePurchaseItem,
    unscrambleDecodePurchaseItem,
    toFillFormTypePurchaseIte,
    hasFieldPurchaseItem,
    newtypePurchaseItem_
};
